import { Clickable, FormikField, P, Tooltip } from '@ahmdigital/ui';
import { useFormikContext } from 'formik';
import React from 'react';

import { INCOME_TIER_NONE } from '../../../../constants';
import { PricingDrawerSchemaType } from '../../../../schema';
import constants from '../../../../../../ahm-constants';
import getIncomeTierOptions from '../../../../../../utils/get-income-tier-options';

const { THIRD_PARTY } = constants.URLS;

type IncomeTierFieldProps = {
  showExplainer?: boolean;
  showTooltip?: boolean;
};

const IncomeTierField = ({ showExplainer = true, showTooltip }: IncomeTierFieldProps) => {
  const { values } = useFormikContext<PricingDrawerSchemaType>();

  const { incomeType } = values;

  const incomeTierOptions = getIncomeTierOptions({ incomeType });

  const allOptions = [
    ...incomeTierOptions,
    {
      text: 'I don’t want to claim the rebate',
      value: INCOME_TIER_NONE,
    },
  ];

  const explanation = (
    <P variant="small14">
      This is your income for{' '}
      <Clickable to={THIRD_PARTY.ATO_MEDICARE_LEVY_SURCHARGE}>Medicare Levy Surcharge</Clickable> purposes, which is
      different to taxable income.{' '}
    </P>
  );

  return (
    <>
      <FormikField
        label={incomeType === constants.INCOME_TYPE.SINGLE ? 'My annual income' : 'Combined annual income'}
        name="incomeTier"
        size="auto"
        inputVariant={['button', 'fullWidth']}
        type="dropdown"
        options={allOptions}
        tooltip={showTooltip && <Tooltip>{explanation}</Tooltip>}
      />

      {showExplainer && explanation}
    </>
  );
};

export default IncomeTierField;
